import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";

export default function ShareDialog({ open, onOpenChange, shareLink, onCopy }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="share-dialog" className="bg-panel border-line text-white rounded-none max-w-xl">
        <DialogHeader>
          <DialogTitle className="font-mono uppercase tracking-widest text-sm">Share Link</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-ink3 font-mono">
          Project state is encoded directly into the URL fragment — no server, no account.
        </p>
        <DialogDescription className="sr-only">
          Copy the generated share link that encodes your project state in the URL.
        </DialogDescription>
        <div className="flex gap-2">
          <Input
            readOnly
            value={shareLink}
            data-testid="share-link-input"
            className="h-9 rounded-none bg-chrome border-line text-foreground text-xs font-mono"
          />
          <Button
            onClick={onCopy}
            data-testid="share-copy-btn"
            className="rounded-none bg-[#002FA7] hover:bg-[#0038C7] text-white h-9 gap-2 font-mono text-xs uppercase"
          >
            <Copy className="h-3.5 w-3.5" />
            Copy
          </Button>
        </div>
        <DialogFooter />
      </DialogContent>
    </Dialog>
  );
}
